<span [attr.data-phosphor-icons]="isPhosphor">
  <i [ngClass]="size">{{ name }}</i>
</span>
